import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { IssuerAPIService } from '../services/issuer-api.service';
declare function responsiveVoiceSpeak(title, innerText): any;
declare function BrowseObligorsponsiveVoiceSpeak(placeholder, inputValue, keyCode, innerText, eventId, controlType, title, htmlFor, alt, key): any;
declare var $: any;
declare function FontSizeSettings(): any;
declare function VoiceOnKeyPress(value, key, eventId): any;

@Component({
  selector: 'app-pandpcusip',
  templateUrl: './pandpcusip.component.html',
  styleUrls: ['./pandpcusip.component.css']
})
export class PandpcusipComponent implements OnInit {
  public IssuerCTPoliciesAndProceduresCUSIPsReportArray: any;
  IsRowExists: string = "1";
  public IsShifttab = 0;
   // Get OBLIGOR_ID from local Storage.
  public obligorId = localStorage.getItem("OBLIGOR_ID");
  IssuerCTPoliciesAndProceduresCUSIPsReport: any = [];
  constructor(private router: Router,private issuerAPIService: IssuerAPIService) { }
  onKeyPress(event: any) {
    if (event.target.id == "inputSuccess5") {
      var btnSearch = <HTMLButtonElement>document.getElementById("btnSearch");
      var btnClear = <HTMLButtonElement>document.getElementById("btnClear");
      if (event.target.value.length > 0) {
        VoiceOnKeyPress(event.target.value, event.key, event.target.id);
        btnSearch.disabled = false;
        btnClear.disabled = false;
      }
      else {
        btnSearch.disabled = true;
        btnClear.disabled = true;
      }
    }
  }
  GobackPage() {
    localStorage.setItem("PPC", "1");
    this.router.navigate(['/compliance-review']);
    return;
  }

  onKeyUp(event: any) {
    debugger;
    if (event.target.id == "returnbackProcedure" && event.keyCode == 13) {
      this.GobackPage();
    }

    // shift + tab and tab to procedure button
    if (event.shiftKey && event.keyCode == 9 && (event.target.id == "tdPar" || event.target.id == "tdpandaCUSIP" || event.target.id == "tdSN" || event.target.id == "tdseries" || event.target.id == "tdDatedDate" || event.target.id == "tdMaturityDate")) {
      document.getElementById("returnbackProcedure").focus();
      this.IsShifttab = 1;
      responsiveVoiceSpeak("", "Return back to Policy & Procedure page. Press enter to return back to policy & procedure page or use tab to go to the text field.");

    }

    if ((event.keyCode == 16) && (event.target.id == "tdPar" || event.target.id == "tdpandaCUSIP" || event.target.id == "tdSN" || event.target.id == "tdseries" || event.target.id == "tdDatedDate" || event.target.id == "tdMaturityDate")) {
      document.getElementById("returnbackProcedure").focus();
      this.IsShifttab = 1;
      responsiveVoiceSpeak("", "Return back to Policy & Procedure page. Press enter to return back to policy & procedure page or use tab to go to the text field.");

    }
    // tab for next element
    if (event.target.id == "returnbackProcedure" && event.keyCode == 9) {
      if (this.IsShifttab == 0) {
        responsiveVoiceSpeak("", "Return back to Policy & Procedure page. Press enter to return back to policy & procedure page or use tab to go to the text field.");
      }
      else {
        this.IsShifttab = 0;
      }
      return;
    }

    if (event.keyCode == 27) {
      document.getElementById("SkipMainContentfooter").focus();
      BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("SkipMainContentfooter").innerText, document.getElementById("SkipMainContentfooter").id, event.target.type, document.getElementById("SkipMainContentfooter").title, event.target.htmlFor, event.target.alt, event.key);
      return;
    }
    $('#hdlastRow').val('0');
    if (event.target.id == "inputSuccess5") {
      var btnSearch = <HTMLButtonElement>document.getElementById("btnSearch");
      var btnClear = <HTMLButtonElement>document.getElementById("btnClear");
      if (event.target.value.length > 0) {
        btnSearch.disabled = false;
        btnClear.disabled = false;
      }
      else {
        btnSearch.disabled = true;
        btnClear.disabled = true;
      }
    }
    if (event.target.id == "tblpandacusipHead" && event.keyCode == 9) {
      this.CountTableRows();
      BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("tblpandacusipHead").innerText, "tblpandacusipHead", event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key);

      return;
    }
    if (event.target.id == "cusippnpdetails" && event.keyCode == 9) {
      responsiveVoiceSpeak("", "Cusips For Policies and Procedures. Heading 1. This page lists all available cusips. You can also search for a specific cusip.  Use escape to skip to footer. Use tab to go to the next field.");
    }
    if (event.target.id == "inputSuccess5" && event.keyCode == 9) {
      responsiveVoiceSpeak("", "Search box. Input a cusip number to search or use tab to go to the cusips table.");
    }
        

    if (event.target.id == "btnSearch" && event.keyCode == 9) {
      responsiveVoiceSpeak("", "Search button. Press enter to search for the cusips or use tab to go the clear button.");
    }
    if (event.target.id == "btnClear" && event.keyCode == 9) {
      responsiveVoiceSpeak("", "Clear button. Press enter to  clear the search result or use tab to go to the table.");
    }
    if (event.target.id == "tdSN" && event.keyCode == 9) {
      document.getElementById("tdSN").focus();
      BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("tdSN").innerText, document.getElementById("tdSN").id, event.target.type, document.getElementById("tdSN").title, event.target.htmlFor, event.target.alt, event.key);
      //responsiveVoiceSpeak("", event.target.innerText + ". Use right arrow key to go to next column.");
    }
    if (event.target.id == "tdSN" && event.keyCode == 27) {
      document.getElementById("SkipMainContentfooter").focus();
      responsiveVoiceSpeak("", event.target.innerText);
    }
    if ((event.shiftKey && event.keyCode == 9) && (event.target.id == "tdPar" || event.target.id == "tdpandaCUSIP" || event.target.id == "tdSN" || event.target.id == "tdseries" || event.target.id == "tdDatedDate" || event.target.id == "tdMaturityDate")) {
      document.getElementById("cusippnpdetails").focus();
      BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("cusippnpdetails").innerText, document.getElementById("cusippnpdetails").id, event.target.type, document.getElementById("inputSuccess5").title, event.target.htmlFor, event.target.alt, event.key);
      return;
    }
    if ((event.target.id == "tdPar" || event.target.id == "tdpandaCUSIP" || event.target.id == "tdpandaCUSIP") && (event.shiftKey && event.keyCode == 9)) {
      document.getElementById("inputSuccess5").focus();
      responsiveVoiceSpeak("", "Search box. Input a cusip number to search or use tab to go to the cusips list.");
    }
   
    // Tabbing on Table
    if (event.keyCode != 17) {
      var child_cell = $(event.target).index();
      if (event.keyCode == 38) {
        this.UpArrowKey(event, child_cell); 
        return;
      }
      else if (event.keyCode == 40) {
        this.DownArrowKey(event);
        return;
      }
      else if (event.keyCode == 39) {
        this.RightArrowKey(event, child_cell);
      }
      else if (event.keyCode == 37) {
        this.LeftArrowKey(event, child_cell);
      }
      else if (event.keyCode == 16)//=============Shift + Tab Go
      {
        if ((event.shiftKey && event.keyCode == 9) && (event.target.id == "tdPar" ||  event.target.id == "tdpandaCUSIP" || event.target.id == "tdSN" || event.target.id == "tdseries" || event.target.id == "tdDatedDate" || event.target.id == "tdMaturityDate")) {
          document.getElementById("cusippnpdetails").focus();
          BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("cusippnpdetails").innerText, document.getElementById("cusippnpdetails").id, event.target.type, document.getElementById("inputSuccess5").title, event.target.htmlFor, event.target.alt, event.key);
        }
      }
    }
  }
  ngOnInit() {
    debugger;
    if (localStorage.getItem("PPC")) {
      localStorage.removeItem("PPC");
    }
    responsiveVoiceSpeak("", "This is Cusips For Policies and Procedures page. Use tab to go to the next field.");
    this.loadIssuerCTPoliciesAndProceduresCUSIPsReport(this.obligorId);
    //=========Caption Hide Show=============//
    if ($('#hidglbVarOnOff').val() == "OFF") {
      $('#captionhideshow').hide();
      $('#btnOnOff').val('OFF')
    }
    else {
      $('#captionhideshow').show();
      $('#btnOnOff').val('ON')
    }

    var btnSearch = <HTMLButtonElement>document.getElementById("btnSearch");
    var btnClear = <HTMLButtonElement>document.getElementById("btnClear");
    btnSearch.disabled = true;
    btnClear.disabled = true;
   
  }
  DownArrowKey(event: any) {
    debugger;
    var innerText, title, child_cell = $(event.target).index();
    $(event.target).parent().next().children("td").eq(child_cell).focus();
    if (event.target.id == "tdSN") {
      if ($(event.target).parent().next().children("td").eq(child_cell).length != 0) {

        if ($(event.target).parent().next().next().children("td").eq(child_cell).length == 0) {
          $('#hdlastRow').val('1');
        }
        else {
          $('#hdlastRow').val('0');
        }

        innerText = $(event.target).parent().next().children("td").eq(child_cell).prevObject[0].innerText;
        title = $(event.target).parent().next().children("td").eq(child_cell).prevObject[0].title;
        BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, innerText, event.target.id, event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key)
      }
    }
    else if (event.target.id == "tdseries") {
     if ($(event.target).parent().next().children("td").eq(child_cell).length != 0) {

        if ($(event.target).parent().next().next().children("td").eq(child_cell).length == 0) {
          $('#hdlastRow').val('1');
        }
        else {
          $('#hdlastRow').val('0');
        }
        innerText = $(event.target).parent().next().children("td").eq(child_cell).prevObject[1].innerText;
        title = $(event.target).parent().next().children("td").eq(child_cell).prevObject[1].title;
        BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, innerText, event.target.id, event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key)
      }
    }
    else if (event.target.id == "tdDatedDate") {
     if ($(event.target).parent().next().children("td").eq(child_cell).length != 0) {

        if ($(event.target).parent().next().next().children("td").eq(child_cell).length == 0) {
          $('#hdlastRow').val('1');
        }
        else {
          $('#hdlastRow').val('0');
        }

        innerText = $(event.target).parent().next().children("td").eq(child_cell).prevObject[2].innerText;
        title = $(event.target).parent().next().children("td").eq(child_cell).prevObject[2].title;

        BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, innerText, event.target.id, event.target.type, title, event.target.htmlFor, event.target.alt, event.key)
      }
    }
    else if (event.target.id == "tdMaturityDate") {
      if ($(event.target).parent().next().children("td").eq(child_cell).length != 0) {

        if ($(event.target).parent().next().next().children("td").eq(child_cell).length == 0) {
          $('#hdlastRow').val('1');
        }
        else {
          $('#hdlastRow').val('0');
        }

        innerText = $(event.target).parent().next().children("td").eq(child_cell).prevObject[3].innerText;
        title = $(event.target).parent().next().children("td").eq(child_cell).prevObject[3].title;

        BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, innerText, event.target.id, event.target.type, title, event.target.htmlFor, event.target.alt, event.key)
      }
    }
    else if (event.target.id == "tdpandaCUSIP") {
      if ($(event.target).parent().next().children("td").eq(child_cell).length != 0) {

        if ($(event.target).parent().next().next().children("td").eq(child_cell).length == 0) {
          $('#hdlastRow').val('1');
        }
        else {
          $('#hdlastRow').val('0');
        }

        innerText = $(event.target).parent().next().children("td").eq(child_cell).prevObject[4].innerText;
        title = $(event.target).parent().next().children("td").eq(child_cell).prevObject[4].title;

        BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, innerText, event.target.id, event.target.type, title, event.target.htmlFor, event.target.alt, event.key)
      }
    }
    else if (event.target.id == "tdPar") {
      if ($(event.target).parent().next().children("td").eq(child_cell).length != 0) {

        if ($(event.target).parent().next().next().children("td").eq(child_cell).length == 0) {
          $('#hdlastRow').val('1');
        }
        else {
          $('#hdlastRow').val('0');
        }

        innerText = $(event.target).parent().next().children("td").eq(child_cell).prevObject[5].innerText;
        title = $(event.target).parent().next().children("td").eq(child_cell).prevObject[5].title;

        BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, innerText, event.target.id, event.target.type, title, event.target.htmlFor, event.target.alt, event.key)
      }
    }
  }
  RightArrowKey(event, child_cell) {
    if (event.target.id == "tdSN") {
      var target = $(event.target).next();
      $(target).trigger('focus');
      if (target[0].id == "tdseries") {
        if ($(event.target).parent().next().children("td").eq(child_cell).length == 0) {
          $('#hdlastRow').val('1');
        }
        else {
          $('#hdlastRow').val('0');
        }

        BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, target[0].innerText, target[0].id, event.target.type, target[0].title, event.target.htmlFor, event.target.alt, event.key)

      }
    }
    if (event.target.id == "tdseries") {
      var target = $(event.target).next();
      $(target).trigger('focus');
      if (target[0].id == "tdDatedDate") {

        if ($(event.target).parent().next().children("td").eq(child_cell).length == 0) {
          $('#hdlastRow').val('1');
        }
        else {
          $('#hdlastRow').val('0');
        }
        BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, target[0].innerText, target[0].id, event.target.type, target[0].title, event.target.htmlFor, event.target.alt, event.key)

      }
    }
    if (event.target.id == "tdDatedDate") {
      var target = $(event.target).next();
      $(target).trigger('focus');
      if (target[0].id == "tdMaturityDate") {

        if ($(event.target).parent().next().children("td").eq(child_cell).length == 0) {
          $('#hdlastRow').val('1');
        }
        else {
          $('#hdlastRow').val('0');
        }
        BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, target[0].innerText, target[0].id, event.target.type, target[0].title, event.target.htmlFor, event.target.alt, event.key)

      }
    }
    if (event.target.id == "tdMaturityDate") {
      var target = $(event.target).next();
      $(target).trigger('focus');
      if (target[0].id == "tdpandaCUSIP") {

        if ($(event.target).parent().next().children("td").eq(child_cell).length == 0) {
          $('#hdlastRow').val('1');
        }
        else {
          $('#hdlastRow').val('0');
        }
        BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, target[0].innerText, target[0].id, event.target.type, target[0].title, event.target.htmlFor, event.target.alt, event.key)

      }
    }
    if (event.target.id == "tdpandaCUSIP") {
      var target = $(event.target).next();
      $(target).trigger('focus');
      if (target[0].id == "tdPar") {

        if ($(event.target).parent().next().children("td").eq(child_cell).length == 0) {
          $('#hdlastRow').val('1');
        }
        else {
          $('#hdlastRow').val('0');
        }
        BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, target[0].innerText, target[0].id, event.target.type, target[0].title, event.target.htmlFor, event.target.alt, event.key)

      }
    }
    if (event.target.id == "tdPar") {
      var obligorDescIndex = 0;
      $(event.target).parent().next().children("td").eq(0).focus();
      if (event.target.id == "tdPar") {
        if (typeof $(event.target).parent().next().children("td").eq(child_cell).prevObject[0] == "object") {
          var innerText = $(event.target).parent().next().children("td").eq(child_cell).prevObject[0].innerText;
          var title = $(event.target).parent().next().children("td").eq(child_cell).prevObject[0].title;

          if ($(event.target).parent().next().children("td").eq(child_cell).length == 0) {
            $('#hdlastRow').val('1');
          }
          else {
            $('#hdlastRow').val('0');
          }

          BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, innerText, "tdSN", event.target.type, "", event.target.htmlFor, event.target.alt, event.key)
        }
      }
    }

  }
  LeftArrowKey(event, child_cell) {
    if (event.target.id == "tdPar") {
      var target = $(event.target).prev();
      $(target).trigger('focus');
      if (target[0].id == "tdpandaCUSIP") {
        if ($(event.target).parent().next().children("td").eq(child_cell).length == 0) {
          $('#hdlastRow').val('1');
        }
        else {
          $('#hdlastRow').val('0');
        }

        BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, target[0].innerText, target[0].id, event.target.type, target[0].title, event.target.htmlFor, event.target.alt, event.key)
      }
    }
    if (event.target.id == "tdpandaCUSIP") {
      var target = $(event.target).prev();
      $(target).trigger('focus');
      if (target[0].id == "tdMaturityDate") {
        if ($(event.target).parent().next().children("td").eq(child_cell).length == 0) {
          $('#hdlastRow').val('1');
        }
        else {
          $('#hdlastRow').val('0');
        }

        BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, target[0].innerText, target[0].id, event.target.type, target[0].title, event.target.htmlFor, event.target.alt, event.key)
      }
    }
    if (event.target.id == "tdMaturityDate") {
      var target = $(event.target).prev();
      $(target).trigger('focus');
      if (target[0].id == "tdDatedDate") {
        if ($(event.target).parent().next().children("td").eq(child_cell).length == 0) {
          $('#hdlastRow').val('1');
        }
        else {
          $('#hdlastRow').val('0');
        }
        BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, target[0].innerText, target[0].id, event.target.type, target[0].title, event.target.htmlFor, event.target.alt, event.key)
      }
    }
    if (event.target.id == "tdDatedDate") {
      var target = $(event.target).prev();
      $(target).trigger('focus');
      if (target[0].id == "tdseries") {
        if ($(event.target).parent().next().children("td").eq(child_cell).length == 0) {
          $('#hdlastRow').val('1');
        }
        else {
          $('#hdlastRow').val('0');
        }

        BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, target[0].innerText, target[0].id, event.target.type, target[0].title, event.target.htmlFor, event.target.alt, event.key)
      }
    }
    if (event.target.id == "tdseries") {
      var target = $(event.target).prev();
      $(target).trigger('focus');
      if (target[0].id == "tdSN") {
        if ($(event.target).parent().next().children("td").eq(child_cell).length == 0) {
          $('#hdlastRow').val('1');
        }
        else {
          $('#hdlastRow').val('0');
        }

        BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, target[0].innerText, target[0].id, event.target.type, target[0].title, event.target.htmlFor, event.target.alt, event.key)
      }
    }
    if (event.target.id == "tdSN") {
      var obligorDescIndex = 3;
      $(event.target).parent().prev().children("td").eq(5).focus();
      if (event.target.id == "tdSN") {
        if (typeof $(event.target).parent().prev().children("td").eq(child_cell).prevObject[5] == "object") {
          var innerText = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[5].innerText;
          var title = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[5].title;
          $('#hdlastRow').val('0');
          BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, innerText, "tdPar", event.target.type, title, event.target.htmlFor, event.target.alt, event.key)
        }
      }
    }

  }
  UpArrowKey(event, child_cell) {
    debugger;
    var innerText;
    var title;
    $(event.target).parent().prev().children("td").eq(child_cell).focus();
    if (event.target.id == "tdSN") {
      innerText = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[0].innerText;
      title = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[0].title;
      BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, innerText, event.target.id, event.target.type, title, event.target.htmlFor, event.target.alt, event.key)
    }
    else if (event.target.id == "tdseries") {
      innerText = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[1].innerText;
      title = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[1].title;
      BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, innerText, event.target.id, event.target.type, title, event.target.htmlFor, event.target.alt, event.key)
    }
    else if (event.target.id == "tdDatedDate") {
      innerText = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[2].innerText;
      title = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[2].title;
      BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, innerText, event.target.id, event.target.type, title, event.target.htmlFor, event.target.alt, event.key)
    }
    else if (event.target.id == "tdMaturityDate") {
      innerText = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[3].innerText;
      title = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[3].title;
      BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, innerText, event.target.id, event.target.type, title, event.target.htmlFor, event.target.alt, event.key)
    }
    else if (event.target.id == "tdpandaCUSIP") {
      innerText = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[4].innerText;
      title = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[4].title;
      BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, innerText, event.target.id, event.target.type, title, event.target.htmlFor, event.target.alt, event.key)
    }
    else if (event.target.id == "tdPar") {
      innerText = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[5].innerText;
      title = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[5].title;
      BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, innerText, event.target.id, event.target.type, title, event.target.htmlFor, event.target.alt, event.key)
    }

  }
   // Load Issuer CT Policies And Procedures CUSIPs Report
  loadIssuerCTPoliciesAndProceduresCUSIPsReport(obligorId: string) {
    document.getElementById("overlay").style.display = "block";
    this.issuerAPIService.GetIssuerCTPoliciesAndProceduresCUSIPsReport(obligorId).subscribe(data => {
      document.getElementById("overlay").style.display = "none";
      debugger;
      this.IssuerCTPoliciesAndProceduresCUSIPsReport = data;

      if (data["length"] == "0") {
        this.IsRowExists = "1";
      }
      else {
        this.IsRowExists = "0";
      }
    if (data["length"] > 0) {
       this.IssuerCTPoliciesAndProceduresCUSIPsReportArray = this.IssuerCTPoliciesAndProceduresCUSIPsReport;
     
    }
    });
    this.MagnifieronDynamicChecking();    
  }
  onCusipSearch() {
    debugger;
    var searchvalue = <HTMLInputElement>document.getElementById("inputSuccess5");
    var serachI = searchvalue.value.toLowerCase();
    var totalRow = 0;
    $("#tblpandacusip tr:gt(0)").filter(function (index) {
    $(this).toggle($(this).find("td:eq(4)").text().toLowerCase().indexOf(serachI) > -1);
      //$(this).toggle($(this).text().toLowerCase().indexOf(serachI) > -1);
    });

    $('#tblpandacusip tr').each(function () {
      console.log($(this).css("display"))
     // console.log($(this).css("display","block"))
      if ($(this).css("display") != "none") {
        totalRow = totalRow + 1;
      }
    });
    
    var totalRowWithoutHeader = totalRow - 1;
    $("#tblrows").val(totalRowWithoutHeader)
    var countRows = totalRowWithoutHeader;
    if (countRows > 0)
      responsiveVoiceSpeak("", countRows.toString() + " cusips found.  Use tab to go the clear button.");
    else
      responsiveVoiceSpeak("", "No cusip found.  Use tab to go the clear button.");
    
  }
  onClear() {
    var searchvalue = <HTMLInputElement>document.getElementById("inputSuccess5");
    searchvalue.value = "";
    responsiveVoiceSpeak("", "Search result cleared. Use tab to go to the list.");
    document.getElementById("inputSuccess5").focus();
    this.IssuerCTPoliciesAndProceduresCUSIPsReportArray = null;
    this.loadIssuerCTPoliciesAndProceduresCUSIPsReport(this.obligorId);
    this.MagnifieronDynamicChecking();
    return;
  }
  CountTableRows() {
    var totalRow = 0
    debugger;
    $('#tblpandacusip tr:gt(0)').each(function () {
      if ($(this).css("display")) {
        if ($(this).css("display") != "none")
          totalRow = totalRow + 1;
      }
      else {
        totalRow = totalRow + 1;
      }
    });
    if (this.IsRowExists == "0") {
      $("#tblrows").val(totalRow)
    }
    else {
      $("#tblrows").val(0)
    }
  }
  MagnifieronDynamicChecking() {
    FontSizeSettings();
  }
}
